import { render } from "./WebIntegrationSettings.vue?vue&type=template&id=5867c86c"
import script from "./WebIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./WebIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__